import React, { useEffect, useState, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  IconButton,
  Tooltip,
  Box,
  Button
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { Row, Col, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
import ReusableGrid from "../../components/ag grid/ReusableGrid";
import AttendanceViewModal from "./AttendanceView";
import AddReportMonth from "./AddAttendanceReportMonth";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import "../../styles/styles.css";
import "../../styles/layout.css";
import usePermission from "../../utils/usePermission";
import AttendanceVeiwController from "../../redux/actions/AttendenceApiAction";
import { getUserInfoFromToken } from "../../utils/authUtils";
import { format, utcToZonedTime } from "date-fns-tz";

const AttendanceTable = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  // const userType = localStorage.getItem("user_type");
  const [userType, setUserType] = useState(null);
  const [userId, setUserId] = useState(null);
  const { getEmployee } = AttendanceVeiwController();
  const { employee } = useSelector((state) => state.TimeAttendance);

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const buttonRef = useRef(null);
  const { hasPermission } = usePermission();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);

  useEffect(() => {
    dispatch(getEmployee());
  }, [dispatch]);

  const formikRef = useRef();
                  useEffect(() => {
                  const { userType, userId } = getUserInfoFromToken();
                  setUserType(userType);
                  setUserId(userId);
                }, []);

  const handleView = (employee) => {
    setSelectedEmployee(employee);
    setShowViewModal(true);
  };

  const handleClearSelection = () => {
    if (gridRef.current) {
      gridRef.current.deselectAll(); // ✅ gridRef is already the api
    }
    setSelectedRows([]);
    setOpenDialog(false);
  };

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      maxWidth: 50,
      pinned: "left"
    },
    {
      headerName: "SR.No",
      valueGetter: (params) => params.node.rowIndex + 1,
      maxWidth: 80
    },
    {
      headerName: "Emp ID",
      field: "employee_id",
      flex: 1
    },
    {
      headerName: "Name",
      valueGetter: (params) =>
        `${params.data.first_name || ""} ${params.data.last_name || ""}`,
      flex: 1
    },
{
  headerName: "Clock In (today)",
  field: "clock_in",
  flex: 1,
  valueFormatter: (params) => {
    if (!params.value) return "-";
    const date = new Date(params.value);
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });
  }
},

{
  headerName: "Clock Out (today)",
  field: "clock_out",
  flex: 1,
  valueFormatter: (params) => {
    if (!params.value) return "-";
    const date = new Date(params.value);
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    });
  }
},
    {
      headerName: "Attendance Status ",
      field: "status",
      flex: 1
    },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      maxWidth: 120,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="View Attendance">
            <IconButton
              color="primary"
              size="small"
              onClick={() => handleView(params.data)}
            >
              <Visibility fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      )
    }
  ];

  return (
    <div>
      <div
        className="d-flex flex-wrap mb-3"
        style={{ gap: "12px", alignItems: "center" }}
      >
        <div className="mt-2">
          {(userType === "Admin" ||
            hasPermission("attendance_management", "generate_report")) && (
            <Button
              ref={buttonRef}
              variant="contained"
              disabled={selectedRows.length === 0}
              color="primary"
              onClick={() => setShowGenerateModal(true)}
              sx={{
                borderRadius: "8px",
                backgroundColor: "#1976d2",
                textTransform: "none",
                paddingX: 2,
                height: "40px",
                fontSize: "0.875rem"
                // minWidth: "250px"
              }}
            >
              Generate Attendance Report
            </Button>
          )}
        </div>
        <div style={{ flexGrow: 1 }} className="mt-2">
          <Form.Control
            type="text"
            placeholder="Search employees..."
            style={{ height: "40px" }}
            value={searchTerm}
            onChange={(e) => {
              const value = e.target.value;
              setSearchTerm(value);

              // Filter the employees
              const lowercasedValue = value.toLowerCase();
              const filtered = employee.filter((emp) => {
                return (
                  emp.first_name?.toLowerCase().includes(lowercasedValue) ||
                  emp.last_name?.toLowerCase().includes(lowercasedValue) ||
                  emp.email?.toLowerCase().includes(lowercasedValue) ||
                  emp.mobile_number?.toLowerCase().includes(lowercasedValue) ||
                  emp.employee_id?.toLowerCase().includes(lowercasedValue)
                );
              });

              setFilteredEmployees(filtered);
            }}
          />
        </div>
        <div>
          <PageSizeSelector
            pageSize={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          />
        </div>
      </div>
      {/* 
      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col>
            <h3>Time Attendance List</h3>
          </Col>
        </Row>
      </div> */}

      <div className="ag-theme-material" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={searchTerm ? filteredEmployees : employee || []}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <AttendanceViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        selectedEmployee={selectedEmployee}
      />

      {showGenerateModal && (
        <AddReportMonth
          handleClose={() => setShowGenerateModal(false)}
          selectedIds={selectedRows.map((row) => row.id)}
          anchorRef={buttonRef}
          onSuccess={() => setOpenDialog(true)} // ✅ Open dialog on success
        />
      )}

      {/* ✅ Success Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>
          <Typography variant="h6" component="div" sx={{ fontWeight: "bold" }}>
            🎉 Generate attendance report complete
          </Typography>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            You have successfully genrate attandance report{" "}
            <strong>{selectedRows.length}</strong> row
            {selectedRows.length > 1 ? "s" : ""}. Would you like to clear the
            current selection?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Box
            display="flex"
            justifyContent="space-between"
            width="100%"
            px={2}
          >
            <Button
              onClick={() => setOpenDialog(false)}
              variant="outlined"
              color="inherit"
              sx={{ borderRadius: 2 }}
            >
              Keep Selection
            </Button>

            <Button
              onClick={handleClearSelection}
              variant="contained"
              color="success"
              sx={{ borderRadius: 2 }}
            >
              Clear Selection
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AttendanceTable;

// import React, { useEffect, useState, useRef } from "react";
// import { AddCircleOutline, Visibility, Delete, Edit } from "@mui/icons-material";
// import { Button, IconButton, Tooltip } from "@mui/material";
// import { Row, Col } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import EmployeeProfileVeiwController from "../../redux/actions/EmployeeProfileApiAction";
// import ReusableGrid from "../../components/ag grid/ReusableGrid";
// import ExportButton from "../../components/ag grid/ExportButton";
// import AttendanceViewModal from "./AttendanceView";
// import "../../styles/styles.css";
// import "../../styles/layout.css";

// const AttendanceTable = () => {
//   const dispatch = useDispatch();
//   const gridRef = useRef(null);

//   const { getEmployees } = EmployeeProfileVeiwController();
//   const { employee_data } = useSelector((state) => state.employeeProfile);

//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [showViewModal, setShowViewModal] = useState(false);
//   const [selectedRows, setSelectedRows] = useState([]);

//   useEffect(() => {
//     dispatch(getEmployees());
//   }, [dispatch]);

//   const handleView = (employee) => {
//     setSelectedEmployee(employee);
//     setShowViewModal(true);
//   };

//   const columnDefs = [
//     {
//       headerCheckboxSelection: true,
//       checkboxSelection: true,
//       maxWidth: 50,
//       pinned: "left",
//     },
//     {
//       headerName: "SR.No",
//       valueGetter: (params) => params.node.rowIndex + 1,
//       maxWidth: 80,
//     },
//     {
//       headerName: "Emp ID",
//       field: "employee_id",
//       flex: 1,
//     },
//     {
//       headerName: "Name",
//       valueGetter: (params) =>
//         `${params.data.first_name || ""} ${params.data.last_name || ""}`,
//       flex: 1,
//     },
//     {
//       headerName: "Email",
//       field: "email",
//       flex: 1,
//     },
//     {
//       headerName: "Contact Number",
//       field: "mobile_number",
//       flex: 1,
//     },
//     {
//       headerName: "Actions",
//       field: "actions",
//       pinned: "right",
//       maxWidth: 120,
//       cellRenderer: (params) => (
//         <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
//           <Tooltip title="View Attendance">
//             <IconButton
//               color="primary"
//               size="small"
//               onClick={() => handleView(params.data)}
//             >
//               <Visibility fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         </div>
//       ),
//     },
//   ];

//   return (
//     <div>
//       <div className="d-flex justify-content-between mb-3">
//         <div>
//           {selectedRows.length > 0 && (
//             <ExportButton

//             />
//           )}
//         </div>
//         <div>
//           <Button
//             variant="contained"
//             startIcon={<AddCircleOutline />}
//             onClick={() => alert("This is a placeholder. Add modal if needed.")}
//           >
//             Add Attendance
//           </Button>
//         </div>
//       </div>

//       <div className="label-card">
//         <Row className="justify-content-between w-100">
//           <Col>
//             <h3>Time Attendance List</h3>
//           </Col>
//         </Row>
//       </div>

//       <div className="ag-theme-material" style={{ height: "70vh" }}>
//         <ReusableGrid
//           rowData={employee_data?.employees || []}
//           columnDefs={columnDefs}
//           gridRef={gridRef}
//           pagination={true}
//           onSelectionChanged={(rows) => setSelectedRows(rows)}
//         />
//       </div>

//       <AttendanceViewModal
//         show={showViewModal}
//         handleClose={() => setShowViewModal(false)}
//         selectedEmployee={selectedEmployee}
//       />
//     </div>
//   );
// };

// export default AttendanceTable;
